import { patchState, signalStore, withComputed, withMethods, withState } from '@ngrx/signals';
import { computed, inject } from '@angular/core';
import { AgencyService } from './agency.service';
import { AgencySaveREQ, InviteAgencyUsersREQ, AgencyViewModel, AgentViewModel } from '../../models/wholesaler-api-models';
import { ToolbarTileViewModel } from '../../models/wholesaler-api-models';

export interface Agency {
  id: number | null;
  agencyDetails: AgencyViewModel | null;
  agency: AgencySaveREQ | null; // Todo: remove agency from here and use agencyDetails instead
  agent: AgentViewModel | null;
  toolbarTiles: ToolbarTileViewModel[] | []; 
  loading: boolean;
}

export const initialState: Agency = {
  id: null,
  agencyDetails: null,
  agency: null,
  agent: null,
  toolbarTiles: [],
  loading: false,
};

export const AgencyStore = signalStore(
  { providedIn: 'root' },
  withState<Agency>(initialState),
  withComputed((state) => ({
    debug: computed(() => ({
      id: state.id(),
      agencyDetails: state.agencyDetails(),
      agency: state.agency(),
      loading: state.loading(),
    })),
  })),
  withMethods((store, agencyService = inject(AgencyService)) => ({
    setAgency(agency: AgencySaveREQ | null) {
      patchState(store, {
        agency: agency,
      });
    },
    setAgent(agent: AgentViewModel | null) {
      patchState(store, {
        agent: agent,
      });
    },
    async getAgency(agencyId: number | null) { 
      if (agencyId === null) {
        return;
      }
      const agency = await agencyService.getAgency(agencyId);
      patchState(store, {
        id: agency.id,
        agencyDetails: agency,
      });
    },
    async upsertAgency(agency: AgencySaveREQ) {
      const agencyId = await agencyService.upsertAgency(agency);
      patchState(store, {
        id: agencyId,
        agency: agency,
      });
    },
    async inviteUsers(invite: InviteAgencyUsersREQ) {
      await agencyService.inviteUsers(invite);
    },
    async updateAgent(agent: AgentViewModel) {
      await agencyService.updateAgent(agent);
    },
    async getAgent(agentId: number) {
      const agent = await agencyService.getAgent(agentId);
      patchState(store, {
        agent: agent,
      });
    },
    async resendInvite(userInviteGuid: string) {
      await agencyService.resendInvite(userInviteGuid);
    },
    async cancelInvite(userInviteGuid: string) {
      await agencyService.cancelInvite(userInviteGuid);
    },
    async getAgencyToolbarTiles(agencyId?: number) {
      if (!agencyId) {
        return;
      }
      const toolbar = await agencyService.getAgencyToolbar(agencyId);
      patchState(store, {
        toolbarTiles: toolbar?.tiles || [],
      });
    },
    reset() {
      patchState(store, initialState);
    },
  }))
);

